import React, { useEffect, useState } from 'react';
import { Box, TextField, Grid, Modal } from '@mui/material';
import RoundButton from '../components/roundButton';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import { uniqueCodeTemplate } from '../../services/bomService';

export default function ModalCustom({
  open,
  modalValue,
  handleClose,
  handleSubmit,
  errorMsg = { isError: false, message: '' }
}) {
  const [submitValue, setSubmitVal] = React.useState(modalValue.value);
  const validEmail = new RegExp(
    '^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$'
  );
  const [errEmail, setErrEmail] = React.useState(errorMsg);
  const [isDisplayConfirmation, setIsDisplayConfirmation] = useState(false);
  const [resultType, setResultType] = useState(0);

  const validateSubmitValue = (submitValue, subType) => {
    let validate = false;

    if (subType == 'share') {
      if ((validate = validEmail.test(submitValue) && submitValue.length > 0)) {
        setErrEmail({ isError: false, message: '' });
        validate = true;
      } else {
        setErrEmail({ isError: true, message: 'Enter valid emailId.' });
        validate = false;
      }
    } else if (subType == 'search') {
      if (submitValue.length > 0 && submitValue != undefined) {
        setErrEmail({ isError: false, message: '' });
        validate = true;
      } else {
        setErrEmail({
          isError: true,
          message: 'Enter valid Configuration Code/ Part Number.'
        });
        validate = false;
      }
    } else if (subType == 'save') {
      if (submitValue.length > 0 && submitValue != undefined) {
        setErrEmail({ isError: false, message: '' });
        validate = true;
      } else {
        setErrEmail({
          isError: true,
          message: 'Enter valid Configuration Code/ Part Number.'
        });
        validate = false;
      }
    }
    return validate;
  };

  const handleConfirmationCancel = () => {
    handleClose();
    setIsDisplayConfirmation(false);
    setErrEmail({ isError: false, message: '' });
  };

  const handleConfirmationYes = async () => {
    await handleSubmit(submitValue, 'search', '', true);
    setIsDisplayConfirmation(false);
  };

  useEffect(() => {
    setSubmitVal(modalValue.value);
  }, [modalValue]);

  const isPartial = () => {
    return resultType == 2;
  };

  const isLegacy = () => {
    return resultType == 3;
  };

  const isErpCode = () => {
    return resultType == 4;
  };

  const isUniqueCode = () => {
    var uniqueCode = uniqueCodeTemplate();
    return resultType == 4 && uniqueCode != '';
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      className="custom-modal-bg"
      hideBackdrop
      disableEscapeKeyDown
    >
      <Box className="modal-common custom-modal">
        <Grid container>
          <Grid item xs={11} sm={11} md={11} lg={11} className="align-center">
            <h5 className="m-1">{modalValue?.heading}</h5>
          </Grid>
          <Grid
            item
            xs={1}
            sm={1}
            md={1}
            lg={1}
            onClick={e => {
              handleConfirmationCancel();
            }}
          >
            <CloseRoundedIcon />
          </Grid>
          <Grid item xs={12}>
            <TextField
              type="text"
              error={errEmail.isError}
              helperText={errEmail.message}
              placeholder={modalValue?.placeholder}
              sx={{
                fontSize: '17px',
                width: '100%',
                padding: '0 5px',
                '& input': {
                  padding: '7px'
                }
              }}
              onChange={e => {
                setSubmitVal(e?.target.value);
              }}
              value={submitValue}
            />
          </Grid>
          <Grid item xs={12}>
            {isDisplayConfirmation && (
              <Grid
                container
                spacing={2}
                sx={{ textAlign: 'center', marginTop: '10px' }}
              >
                <Grid item xs={12}>
                  {isPartial() && 'A close match was found:'}
                  {isLegacy() &&
                    'A match was found for a legacy configuration code:'}
                  {isUniqueCode() && 'A match was found for a unique code:'}
                  {isErpCode() && 'A match was found for a ERP code:'}
                </Grid>
                <Grid item xs={12}>
                  {submitValue}
                </Grid>
                <Grid item xs={12}>
                  Load the one we found?
                </Grid>
                <Grid item xs={6}>
                  <RoundButton
                    name="Yes"
                    onClick={() => {
                      handleConfirmationYes();
                      handleClose();
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <RoundButton
                    name="No"
                    onClick={() => handleConfirmationCancel()}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
          {!isDisplayConfirmation && (
            <>
              <Grid item xs={0} sm={9} md={9} lg={9}></Grid>
              <Grid item xs={12} sm={3} md={3} lg={3}>
                <RoundButton
                  name={modalValue?.button}
                  onClick={async () => {
                    if (
                      validateSubmitValue(submitValue, modalValue.submitType)
                    ) {
                      let promise = new Promise(async (resolve, reject) => {
                        resolve(
                          await handleSubmit(submitValue, modalValue.submitType)
                        );
                      })
                        .then(result => {
                          if (result === 0) {
                            setErrEmail({
                              isError: true,
                              message: 'No Result(s) Found'
                            });
                            setSubmitVal('');
                            setIsDisplayConfirmation(false);
                            setResultType(0);
                          } else if (
                            result === 2 ||
                            result === 3 ||
                            result === 4
                          ) {
                            setIsDisplayConfirmation(true);
                            setResultType(result);
                          } else {
                            handleClose();
                            setIsDisplayConfirmation(false);
                            setErrEmail({ isError: false, message: '' });
                            setResultType(0);
                          }
                        })
                        .catch(error => {
                          console.log(error);
                        });
                    }
                  }}
                />
              </Grid>
            </>
          )}
        </Grid>
      </Box>
    </Modal>
  );
}
